/*	assets/filthy.js	*/
/* joelbrennan0.uk - original */
$(function() {
  $('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: (($(target).offset().top) -50)
        }, 1000);
        return false;
      }
    }
  });
});



// jQuery to add grey class on scroll
$(window).scroll(function() {
    if ($(".navbar").offset().top > 50) {
        $(".navbar-nav li a").addClass("grey");
    } else {
        $(".navbar-nav li a").removeClass("grey");       
    }
});